import { MUSTNeverHappenException, tsValidateArray, tsValidateIsInRange, tsValidateResult, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { EHR_OrderConfigSources, ehrOrderAvailability_Always, ehrOrderAvailability_Partial } from './types.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_GeneratedProps = {};
const Validator_EHR_OrderConfigAvailability_Partial_Data = {
    start: tsValidateIsInRange([[0, 1440]]), //A number between 0 and 24*60, the total minutes in a day.
    end: tsValidateIsInRange([[0, 1440]]),
};
const Validator_EHR_OrderConfigAvailability_Always = {
    type: tsValidateValue([ehrOrderAvailability_Always]),
};
const Validator_EHR_OrderConfigAvailability_Partial = {
    type: tsValidateValue([ehrOrderAvailability_Partial]),
    data: {
        sun: tsValidateArray(Validator_EHR_OrderConfigAvailability_Partial_Data),
        mon: tsValidateArray(Validator_EHR_OrderConfigAvailability_Partial_Data),
        tue: tsValidateArray(Validator_EHR_OrderConfigAvailability_Partial_Data),
        wed: tsValidateArray(Validator_EHR_OrderConfigAvailability_Partial_Data),
        thu: tsValidateArray(Validator_EHR_OrderConfigAvailability_Partial_Data),
        fri: tsValidateArray(Validator_EHR_OrderConfigAvailability_Partial_Data),
        sat: tsValidateArray(Validator_EHR_OrderConfigAvailability_Partial_Data),
    }
};
const Validator_EHR_OrderConfigAvailability = (instance) => {
    if (instance?.type === ehrOrderAvailability_Always)
        return tsValidateResult(instance, Validator_EHR_OrderConfigAvailability_Always);
    if (instance?.type === ehrOrderAvailability_Partial)
        return tsValidateResult(instance, Validator_EHR_OrderConfigAvailability_Partial);
    // @ts-ignore
    throw new MUSTNeverHappenException(`Unknown availability type ${instance?.type}`);
};
const Validator_ModifiableProps = {
    ehrInstanceId: tsValidateUniqueId,
    orderId: tsValidateUniqueId,
    ehrOrderId: tsValidateString(-1, false),
    source: tsValidateValue([...EHR_OrderConfigSources], false),
    availability: Validator_EHR_OrderConfigAvailability
};
export const DBDef_EHROrderConfiguration = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'ehr-order-configuration',
    entityName: 'EHROrderConfiguration',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'ehr-order-configuration'
    },
    backend: {
        name: 'ehr-order-configuration'
    },
    dependencies: {
        orderId: {
            dbKey: 'orders',
            fieldType: 'string'
        },
        ehrInstanceId: {
            dbKey: 'ehr-instances',
            fieldType: 'string'
        }
    }
};
//# sourceMappingURL=db-def.js.map